const hasStatus = (error: unknown, status: number): boolean =>
	typeof error === "object" &&
	error !== null &&
	"status" in error &&
	error.status === status;

export const isForbiddenError = (error: unknown): boolean =>
	hasStatus(error, 403);

export const isMissingOrForbidden = (error: unknown): boolean =>
	hasStatus(error, 403) || hasStatus(error, 404);
